/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// import mbpLogger from 'mbp-logger';

export const generateMyAccountDataLayer = ({
    location,
}, pageDataLayer) => {
    const dataLayer = { ...pageDataLayer };

    // Account Home
    if (location.pathname === '/account') {
        dataLayer.pageType = 'myaccount';
        dataLayer.pageName = 'MyAccount';
    }
    // Account: OrderTracking
    if (location.pathname === '/account/orders') {
        dataLayer.pageType = 'ordertracking';
        dataLayer.pageName = 'OrderTrackingSearch';
    }
    // Account: AddressBook
    if (location.pathname === '/account/address-book') {
        dataLayer.pageType = 'addressbook';
        dataLayer.pageName = 'MyAccount';
    }
    // Account: Manage Subscriptions
    if (location.pathname === '/account/subscriptions') {
        dataLayer.pageType = 'subscription';
        dataLayer.pageName = 'MyAccount';
    }
    // Account: Payment & Billing
    if (location.pathname === '/account/billing-address') {
        dataLayer.pageType = 'billingaddress';
        dataLayer.pageName = 'MyAccount';
    }
    // Account: Change Password
    if (location.pathname === '/account/change-password') {
        dataLayer.pageType = 'changepassword';
        dataLayer.pageName = 'MyAccount';
    }
    // Account: Change Email
    if (location.pathname === '/account/change-email') {
        dataLayer.pageType = 'changeemail';
        dataLayer.pageName = 'MyAccount';
    }
    // Account: Promotions and Offers
    if (location.pathname === '/account/email-preference') {
        dataLayer.pageType = 'emailpreference';
        dataLayer.pageName = 'MyAccount';
    }
    // Account: Passport
    if (location.pathname === '/account/passport') {
        dataLayer.pageType = 'accountpassport';
        dataLayer.pageName = 'MyAccount';
    }
    // Account: Change Password
    if (location.pathname === '/account/wishlist') {
        dataLayer.pageType = 'wishlist';
        dataLayer.pageName = 'MyAccount';
    }
    return dataLayer;
};

export default {};
